var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoucherIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9366 17.9366C18.5708 17.3023 19.5922 17.3023 20.2264 17.9366L22.0961 16.0668C22.4256 15.7374 22.4256 15.2102 22.0961 14.889L11.4543 4.2471C11.1248 3.91763 10.5976 3.91763 10.2764 4.2471L8.40666 6.11684C9.04089 6.75107 9.04089 7.77243 8.40666 8.40666C7.77243 9.04089 6.75107 9.04089 6.11684 8.40666L4.2471 10.2764C3.91763 10.6059 3.91763 11.133 4.2471 11.4543L14.889 22.0961C15.2185 22.4256 15.7456 22.4256 16.0668 22.0961L17.9366 20.2264C17.3023 19.5922 17.3023 18.5708 17.9366 17.9366Z",
    fill: "white",
    stroke: "#E60063",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1815 11.208C14.1264 11.208 14.8943 11.9759 14.8943 12.9208V14.6336H13.1815C12.2367 14.6336 11.4688 13.8656 11.4688 12.9208C11.4688 11.9759 12.2367 11.208 13.1815 11.208Z",
    stroke: "#E60063",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherIcon);
export default __webpack_public_path__ + "static/media/voucher_icon.aa0a448bbc25263f1b0472fa7dd60c37.svg";
export { ForwardRef as ReactComponent };